import { createContext, useContext, useState } from 'react';

const now = new Date();

const defaultPeriod = {
  year: now.getFullYear(),
  month: now.getMonth() + 1,
  mode: 'month', // 'month' | 'quarter' | 'year' | 'custom'
  from: null,
  to: null,
};

export const PeriodContext = createContext({
  period: defaultPeriod,
  setPeriod: () => {},
});

export function PeriodProvider({ children }) {
  const [period, setPeriod] = useState(defaultPeriod);
  return (
    <PeriodContext.Provider value={{ period, setPeriod }}>
      {children}
    </PeriodContext.Provider>
  );
}

export function usePeriod() {
  return useContext(PeriodContext);
}

/**
 * Retourne les bornes ISO (from / to) du mois courant du contexte période.
 */
export function usePeriodRange() {
  const { period } = usePeriod();
  if (period.mode === 'custom' && period.from && period.to) {
    return { from: period.from, to: period.to };
  }
  if (period.mode === 'year') {
    return {
      from: `${period.year}-01-01`,
      to: `${period.year}-12-31`,
    };
  }
  if (period.mode === 'quarter') {
    const qStart = Math.floor((period.month - 1) / 3) * 3 + 1;
    const qEnd = qStart + 2;
    const startDate = new Date(period.year, qStart - 1, 1);
    const endDate = new Date(period.year, qEnd, 0);
    return {
      from: startDate.toISOString().split('T')[0],
      to: endDate.toISOString().split('T')[0],
    };
  }
  // default: month
  const startDate = new Date(period.year, period.month - 1, 1);
  const endDate = new Date(period.year, period.month, 0);
  return {
    from: startDate.toISOString().split('T')[0],
    to: endDate.toISOString().split('T')[0],
  };
}
